import React from "react";
import { Box, Typography } from "@mui/material";

const EmptyState = ({ message, color }) => (
    <Box py={4} textAlign="center">
        <Typography color="text.secondary" fontSize={14} fontFamily="Montserrat, sans-serif">
            {message}
        </Typography>
        <Typography color={color || "text.disabled"} fontSize={12} mt={0.5}>
            Les données apparaîtront ici une fois disponibles.
        </Typography>
    </Box>
);

export default EmptyState;
